import { ErrorHandler } from '@angular/core';
import * as StackTrace from 'stacktrace-js';

export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    console.log('passei pelo handler', error)
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/error/global-error-handler/global-error-handler.component.ts